{
  "profile": {
    "dateOfBirth": "Date of birth",
    "phone": "Phone",
    "emergencyContactName": "Emergency contact name",
    "emergencyContactPhone": "Emergency contact phone",
    "relationship": "Relationship",
    "medicalNotes": "Medical notes"
  }
}
